var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacilityRestRoom = function SvgFacilityRestRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M212-80v-300h-50v-300h248v300h-50v300zm74.08-654q-30.08 0-51.58-21.42t-21.5-51.5 21.42-51.58 51.5-21.5 51.58 21.42q21.5 21.421 21.5 51.5t-21.42 51.58q-21.421 21.5-51.5 21.5M630-80v-240H526l100-360h116l100 360H738v240zm54.08-654q-30.08 0-51.58-21.42t-21.5-51.5 21.42-51.58q21.421-21.5 51.5-21.5t51.58 21.42q21.5 21.421 21.5 51.5t-21.42 51.58q-21.421 21.5-51.5 21.5"
  })));
};
export default SvgFacilityRestRoom;